export const FlowType = {
  STANDARD: "STANDARD",
  CUSTOMIZING: "CUSTOMIZING",
  CSV_IMPORTER: "CSV_IMPORTER",
  PROCESS_ENGINE: "PROCESS_ENGINE"
};
